import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Col, Container, Row, Table } from "react-bootstrap";
import { RootState } from "../reducers";
import Loading from "./Loading";
import { fetchTrackingSale } from "../actions/shopActions";
import ProductTagsTypes from "./ProductTagsTypes";
import Moment from "react-moment";
import { useParams } from 'react-router-dom';

const TrackingSale = () => {
  const isLoading = useSelector((state: RootState) => state.shop.isLoading);
  const trackingSale = useSelector(
    (state: RootState) => state.shop.trackingSale)
  const { saleId, clientId }: any = useParams()
  const dispatch: any = useDispatch()
  useEffect(() => {
    dispatch(fetchTrackingSale({ saleId, clientId }));
  }, [dispatch, saleId, clientId]);

  return (
    <Container>
      {!isLoading ? (
        <Row>
          <Col>
            <Card className="mb-3">
              <Card.Body>
                <Card.Title>Pedido #{trackingSale?.sale?.number}</Card.Title>
                <ul>
                  {trackingSale?.sale?.status_details?.length > 0 &&
                    trackingSale?.sale?.status_details?.map(
                      (item: any, index: number) => (
                        <li key={index}>
                          <h5>{item.sale_status.name}</h5>
                          <p>
                            <Moment format="DD/MM/YY HH:mm">
                              {item.created_at}
                            </Moment>
                          </p>
                        </li>
                      )
                    )}
                  {trackingSale?.sale?.traking_code && (
                    <li>
                      <h5>Código de segumiento</h5>
                      <p>{trackingSale?.sale?.traking_code}</p>
                      <p>
                        <a
                          rel="noreferrer"
                          target="_blank"
                          href="https://www.correoargentino.com.ar/formularios/ondnc"
                        >
                          Link Correo Argentino
                        </a>
                      </p>
                    </li>
                  )}
                </ul>
              </Card.Body>
            </Card>
            <Card className="mb-3">
              <Card.Body>
                <Card.Title>Tus datos</Card.Title>
                <ul>
                  <li>
                    {trackingSale?.sale?.client.name +
                      " " +
                      trackingSale?.sale?.client.last_name}
                  </li>
                  <li>
                    {trackingSale?.sale?.client.address +
                      ", " +
                      trackingSale?.sale?.client.city +
                      ", " +
                      trackingSale?.sale?.client.postal_code +
                      ", " +
                      trackingSale?.sale?.client.provinces?.name}
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card className="mb-3">
              <Card.Body>
                <Table className="text-center align-middle">
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>Precio</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {trackingSale?.saleDetails?.length > 0 &&
                        trackingSale?.saleDetails?.map(
                          (item: any, index: number) => (
                            <tr key={index}>
                              <td>{item.quantity}</td>
                              <td>
                                {item.product.name}{" "}
                                {item.product.types?.length > 0 && (
                                  <ProductTagsTypes
                                    types={item.product.types}
                                  />
                                )}
                              </td>
                              <td>${item.total_amount}</td>
                            </tr>
                          )
                        )}
                      {trackingSale?.sale?.subtotal !== trackingSale?.sale?.total && <tr>
                        <td colSpan={2} className="text-end">
                          Subtotal:
                        </td>
                        <td>${trackingSale?.sale?.subtotal} {trackingSale?.sale?.increase1 > 0 && ` + ${trackingSale?.sale?.increase1}%`}</td>
                      </tr>}
                      <tr>
                        <td colSpan={2} className="text-end">
                          <h5>Total:</h5>
                        </td>
                        <td><h5>${trackingSale?.sale?.total}</h5></td>
                      </tr>
                    </>
                  </tbody>
                  <tfoot></tfoot>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : (
        <Loading />
      )}
    </Container>
  );
};
export default TrackingSale;
